import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { addAudit, editAudit, auditDetail, markList, typeList } from './request';
import { applicationResource } from '../../customer/applicationManage/request';
import { customerResource } from '../../system/customerManage/request';
import { auditTypeResource } from './../typeManage/request';
import { auditFlowInsuranceResource } from '@/views/insurance/insuranceManage/request';
import { auditFlowClaimsTypeResource } from '@/views/claim/typeManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { structureList } from '../../customer/accountManage/request';
export default {
  props: ['id'],
  data() {
    return {
      dataFrom: {
        flowTypeId: undefined,
        applicationId: undefined,
        claimsTypeId: []
      },
      dialogVisible: false,
      customerList: [],
      customerInsuranceId: null,
      applicationList: [],
      claims: [],
      claimsList: [],
      markList,
      typeList,
      flowTypeList: [],
      productList: [],
      claimsTypeList: [],
      visiblePersonnelData: []
    };
  },
  created() {
    this.init();
  },
  computed: {
    // 自定义验证规则
    // validator: 自定义验证方法，用于执行复杂的验证逻辑。
    // $t 方法用于进行国际化翻译
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('审核流名称')
        }],
        type: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('审核流类型')
        }],
        flowMark: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('标识')
        }],
        customerId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('归属客户')
        }],
        flowTypeId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('审核流类型')
        }],
        applicationId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('归属应用')
        }],
        customerInsuranceId: [{
          required: true,
          trigger: 'change',
          validator: this.validateApplicationId
        }]
      };
    }
  },
  methods: {
    // 自定义验证规则
    validateApplicationId(rule, value, callback) {
      if (this.customerInsuranceId.length == 0 && (this.dataFrom.flowMark == 'product_launch' || this.dataFrom.flowMark == 'product_change')) {
        callback(new Error(this.$t('请选择') + this.$t('产品')));
      } else if (!this.customerInsuranceId && this.dataFrom.flowMark == 'claims') {
        callback(new Error(this.$t('请选择') + this.$t('产品')));
      } else {
        callback();
      }
    },
    init() {
      customerResource().then(res => {
        this.customerList = res;
      });
      auditTypeResource({}).then(res => {
        this.flowTypeList = res;
      });
      if (this.id != -1) {
        auditDetail({
          auditFlowId: this.id
        }).then(res => {
          this.dataFrom = res;
          this.dataFrom.userId = res.userId ? res.userId.split(',') : [];
          this.dataFrom.auditFlowId = this.id;
          this.getDataFun();
          if (this.dataFrom.flowMark != 'version_online') {
            if (this.dataFrom.flowMark == 'claims') {
              // this.claimsTypeList = res.claimsType;
              this.dataFrom.claimsTypeId = [];
              // res.claimsType.map(item => {
              //   this.dataFrom.claimsTypeId.push(item.claimsTypeId);
              // });
              // if (res.claimsTypeId.indexOf(',') > -1) {
              //   this.dataFrom.claimsTypeId = res.claimsTypeId.split(',');
              // } else {
              //   = [Number(res.claimsTypeId)];
              // }
            } else if (this.dataFrom.flowMark == 'product_launch' || this.dataFrom.flowMark == 'product_change') {
              this.productList = res.customerInsurance;
              this.dataFrom.customerInsuranceId = [];
              res.customerInsurance.map(item => {
                this.dataFrom.customerInsuranceId.push(String(item.customerInsuranceId));
              });
            }
            this.customerInsuranceId = this.dataFrom.customerInsuranceId;
            this.getProductFun(true);
          }
          if (this.dataFrom.flowMark === 'questionnaire' && this.dataFrom.customerId) {
            this.getVisiblePersonnelData();
          }
        });
      }
      this.dialogVisible = true;
    },
    handleSure() {
      // if (this.id == -1 && this.claimsTypeList.length == 0 && this.dataFrom.flowMark == 'claims') {
      //   this.$message.error(this.$t('没有可配置的理赔类型,无法创建'));
      //   return false;
      // }
      if (this.id == -1 && this.productList.length == 0 && (this.dataFrom.flowMark == 'product_launch' || this.dataFrom.flowMark == 'product_change')) {
        this.$message.error(this.$t('没有可配置的产品,无法创建'));
        return false;
      }
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let parameter = recursionCopy(this.dataFrom);
          if (parameter.userId) {
            parameter.userId = parameter.userId.join(',');
          }
          if (this.dataFrom.flowMark == 'product_launch' || this.dataFrom.flowMark == 'product_change') {
            parameter.customerInsuranceId = this.customerInsuranceId.join(',');
          } else if (this.dataFrom.flowMark == 'claims') {
            parameter.customerInsuranceId = String(this.customerInsuranceId);
          } else {
            delete parameter.customerInsuranceId;
          }
          // if (this.dataFrom.flowMark == 'claims' && this.dataFrom.claimsTypeId.length != 0) {
          //   parameter.claimsTypeId = parameter.claimsTypeId.join(',');
          // } else {
          //   // delete parameter.claimsTypeId;
          // }
          let fun = parameter.auditFlowId ? editAudit : addAudit;
          fun(parameter).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok', res);
          });
        }
      });
    },
    getDataFun() {
      // this.flowMarkChangeFun()
      applicationResource({
        customerId: this.dataFrom.customerId
      }).then(res => {
        this.applicationList = res;
      });
    },
    async getProductFun(type) {
      const res = await auditFlowInsuranceResource({
        customerId: this.dataFrom.customerId,
        applicationId: this.dataFrom.applicationId,
        flowMark: this.dataFrom.flowMark
      });
      if (type) {
        if (this.id == -1) {
          this.productList = res;
        } else {
          this.productList = this.productList.concat(res);
        }
        // if (this.dataFrom.flowMark == 'claims') {
        //   this.getProductTypeFun(type);
        // }
      } else {
        this.productList = res;
      }
    },
    async getProductTypeFun(type) {
      if (this.dataFrom.flowMark != 'claims') {
        return false;
      }
      const arr = this.productList.filter(item => item.customerInsuranceId == type);
      // const res = await auditFlowClaimsTypeResource({
      //   customerId: this.dataFrom.customerId,
      //   applicationId: this.dataFrom.applicationId,
      //   flowMark: this.dataFrom.flowMark,
      //   customerInsuranceId: this.customerInsuranceId,
      //   insuranceId: arr[0].insuranceId
      // });
      // if (type) {
      //   if (this.id == -1) {
      //     this.claimsTypeList = res;
      //   } else {
      //     this.claimsTypeList = this.claimsTypeList.concat(res);
      //   }
      // } else {
      //   this.claimsTypeList = res;
      // }
    },
    flowMarkChangeFun() {
      if (this.dataFrom.flowMark == 'claims') {
        this.customerInsuranceId = undefined;
      } else {
        this.customerInsuranceId = [];
      }
      this.dataFrom.claimsTypeId = [];
    },
    disabledFun2() {
      if (!this.dataFrom.auditFlowId) {
        return this.dataFrom.customerId ? false : true;
      } else {
        if (this.dataFrom.flowMark == 'product_launch' || this.dataFrom.flowMark == 'product_change') {
          return false;
        } else {
          return true;
        }
      }
    },
    disabledFun() {
      if (!this.dataFrom.flowMark) {
        return true;
      } else if (!this.dataFrom.auditFlowId) {
        return this.dataFrom.customerId ? false : true;
      } else {
        return true;
      }
    },
    productModeFun(flowMark) {
      return flowMark == 'product_launch' ? 'multiple' : flowMark == 'product_change' ? 'multiple' : 'default';
    },
    productPropFun(flowMark) {
      return flowMark == 'product_launch' ? 'product' : flowMark == 'product_change' ? 'product' : 'customerInsuranceId';
    },
    customIdChange() {
      //归属客户改变时，应用清空
      this.dataFrom.applicationId = undefined;
      this.getDataFun();
      this.flowMarkChangeFun();
      this.getVisiblePersonnelData();
    },
    getVisiblePersonnelData() {
      this.visiblePersonnelData = [];
      structureList({
        customerId: this.dataFrom.customerId
      }).then(res => {
        let loop = data => {
          return data.map(item => {
            let obj = {
              title: item.name,
              value: item.id,
              name: item.name,
              id: item.id,
              label: item.name,
              disabled: true
            };
            if (item.children && item.children.length) {
              obj.children = loop(item.children);
            }
            if (item.userInfo && item.userInfo.length > 0) {
              obj.children = obj.children || [];
              item.userInfo.forEach(userItem => {
                let user = {
                  title: userItem.nickName,
                  value: userItem.userId,
                  name: userItem.nickName,
                  id: userItem.userId,
                  label: userItem.nickName + ' ' + userItem.mobile
                };
                obj.children.push(user);
              });
            }
            return obj;
          });
        };
        this.visiblePersonnelData = loop(res);
      });
    },
    onChange() {}
  }
};